import axiosInstance from "./AxiosInstance";

// Get assigned (booked - unconfirmed) appointments
export function getAssignedAppointments(payload) {
  return axiosInstance.post("receptionist/appointments", payload);
}

// Get confirmed appointments grouped by time slots
export function getConfirmedAppointments(payload) {
  return axiosInstance.post("receptionist/appointments/confirmed", payload);
}

// Get available time slots for a doctor
export function getAvailableTimeSlots(payload) {
  return axiosInstance.post("receptionist/time-slots", payload);
}

// Assign doctor to appointment
export function doctorAssign(data) {
  return axiosInstance.post("receptionist/appointments/assign-doctor", data);
}

// Confirm appointment
export function confirmAppointment(data) {
  return axiosInstance.post("receptionist/appointments/confirm", data);
}

// Reschedule appointment
export function rescheduleAppointment(data) {
  return axiosInstance.post("receptionist/appointments/reschedule", data);
}

// Remove appointment
export function removeAppointment(appointmentId) {
  return axiosInstance.post("receptionist/appointments/remove", {
    appointment_id: appointmentId,
  });
}

// Move back to queue
export function moveBackToQueue(appointmentId) {
  return axiosInstance.post("receptionist/moveBackToQueue", {
    appointment_id: appointmentId,
  });
}
